<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">
        {{ $t('inventory.operation.stock_transfer.details') }}
      </h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('inventory.operation.stock_transfer.transfer_info') }}
                  </legend>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.transfer') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.trans_number }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.date') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.transfer_date }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.from_branch') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.branch_name_en }}</div>
                    <div class="col-md-3 text-right">
                      {{
                        $t('inventory.operation.stock_transfer.from_location')
                      }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.location_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.to_branch') }} :
                    </div>
                    <div class="col-md-3">{{ data.to_branch_name_en }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.to_location') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.to_location_name }}</div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{
                        $t('inventory.operation.stock_transfer.transfered_by')
                      }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.transferred_by_name }}</div>
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.recieved_by') }}
                      :
                    </div>
                    <div class="col-md-3">{{ data.received_by_name }}</div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 text-right">
                      {{ $t('inventory.operation.stock_transfer.status') }} :
                    </div>
                    <div class="col-md-3">
                      <span :class="statusStyle(data.transfer_status_id)">{{
                        status(data.transfer_status_id)
                      }}</span>
                    </div>
                    <div class="col-md-3 text-right">
                      {{
                        $t('inventory.operation.stock_transfer.total_amount')
                      }}
                      :
                    </div>
                    <div class="col-md-3">
                      $ {{ format_number(data.total_amount) }}
                    </div>
                    <div class="col-md-3 text-right"></div>
                    <div class="col-md-3"></div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form>
                <fieldset>
                  <legend>
                    {{
                      $t('inventory.operation.stock_transfer.transfer_details')
                    }}
                  </legend>
                  <div class="overflow-auto ts-h-40">
                    <table class="table table-hover ui-table ts-table">
                      <thead>
                        <tr>
                          <th style="width: 15px" class="text-center">
                            {{ $t('inventory.operation.stock_transfer.no') }}
                          </th>
                          <th style="width: 15px" class="text-center">
                            {{
                              $t('inventory.operation.stock_transfer.barcode')
                            }}
                          </th>
                          <th>
                            {{
                              $t('inventory.operation.stock_transfer.product')
                            }}
                          </th>
                          <th class="text-center">
                            {{ $t('inventory.operation.stock_transfer.uom') }}
                          </th>
                          <th class="text-center">
                            {{ $t('inventory.operation.stock_transfer.cost') }}
                          </th>
                          <th class="text-center">
                            {{ $t('inventory.operation.stock_transfer.qty') }}
                          </th>
                          <th class="text-center">
                            {{
                              $t('inventory.operation.stock_transfer.amount')
                            }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in datasource" :key="index">
                          <td class="text-center text-nowrap">
                            {{ index + 1 }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.barcode }}
                          </td>
                          <td class="text-left text-nowrap">
                            {{ record.product_name_en }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.uom_name_en }}
                          </td>
                          <td class="text-center text-nowrap">
                            $ {{ format_number(record.cost) }}
                          </td>
                          <td class="text-center text-nowrap">
                            {{ record.qty }}
                          </td>
                          <td class="text-center text-nowrap">
                            $ {{ format_number(record.cost * record.qty) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
export default {
  name: 'previewDetail',
  props: ['data'],
  data() {
    return {
      waiting: false,
      status_id: 1,
      datasource: []
    }
  },
  computed: {
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case 1:
          badge = 'badge badge-info'
          break
        case 2:
          badge = 'badge badge-primary'
          break
        case 3:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    status: () => status => {
      let value = ''

      switch (status) {
        case 1:
          value = 'Pending'
          break
        case 2:
          value = 'Recieved'
          break
        case 3:
          value = 'Rejected'
          break
      }

      return value
    }
  },
  created() {
    this.setDetails()
  },
  methods: {
    setDetails() {
      this.datasource = this.data.stock_transfer_details
    },
    format_number(value) {
      return parseFloat(value).toFixed(2)
    }
  }
}
</script>
<style scoped>
table > thead > tr > th,
table > tbody > tr > td {
  padding: 3px 5px;
}
.table > thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>
